import { injectable } from '@actr/di';
import { AuthStore } from '@actr/stores/src/stores/stores/account/auth/auth';
import { action, computed, makeObservable, observable } from 'mobx';

@injectable()
export default class LocalAuthStore extends AuthStore {

  @observable
  protected _loginOpened = false;

  constructor() {
    super();
    makeObservable(this);
  }

  @computed
  get loginOpened(): boolean {
    return this._loginOpened;
  }

  @action
  toggleOpenLoginForm(isOpen?: boolean): void {
    this._loginOpened = isOpen !== undefined ? isOpen : !this._loginOpened;
  }

}
